module.exports = __webpack_public_path__ + "static/media/corkease-3.8c9c7f20.jpg";